module.exports = __webpack_public_path__ + "img/logoInteliteAzul.ba55a4b9.png";